import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';
import { createEntity, getEntity, reset, updateEntity } from './economic-activity-status.reducer';

export const EconomicActivityStatusUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const economicActivityStatusEntity = useAppSelector(state => state.economicActivityStatus.entity);
  const loading = useAppSelector(state => state.economicActivityStatus.loading);
  const updating = useAppSelector(state => state.economicActivityStatus.updating);
  const updateSuccess = useAppSelector(state => state.economicActivityStatus.updateSuccess);
  const geographicLevelValues = Object.keys(GeographicLevel);

  const handleClose = () => {
    navigate(`/economic-activity-status${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.totalAllUsualResidents !== undefined && typeof values.totalAllUsualResidents !== 'number') {
      values.totalAllUsualResidents = Number(values.totalAllUsualResidents);
    }
    if (values.economicallyActiveTotal !== undefined && typeof values.economicallyActiveTotal !== 'number') {
      values.economicallyActiveTotal = Number(values.economicallyActiveTotal);
    }
    if (values.inEmployment !== undefined && typeof values.inEmployment !== 'number') {
      values.inEmployment = Number(values.inEmployment);
    }
    if (values.employeePartTime !== undefined && typeof values.employeePartTime !== 'number') {
      values.employeePartTime = Number(values.employeePartTime);
    }
    if (values.employeeFullTime !== undefined && typeof values.employeeFullTime !== 'number') {
      values.employeeFullTime = Number(values.employeeFullTime);
    }
    if (values.selfEmployed !== undefined && typeof values.selfEmployed !== 'number') {
      values.selfEmployed = Number(values.selfEmployed);
    }
    if (values.unemployed !== undefined && typeof values.unemployed !== 'number') {
      values.unemployed = Number(values.unemployed);
    }
    if (values.economicallyInactiveTotal !== undefined && typeof values.economicallyInactiveTotal !== 'number') {
      values.economicallyInactiveTotal = Number(values.economicallyInactiveTotal);
    }
    if (values.retired !== undefined && typeof values.retired !== 'number') {
      values.retired = Number(values.retired);
    }
    if (values.student !== undefined && typeof values.student !== 'number') {
      values.student = Number(values.student);
    }
    if (values.lookingAfterHomeFamily !== undefined && typeof values.lookingAfterHomeFamily !== 'number') {
      values.lookingAfterHomeFamily = Number(values.lookingAfterHomeFamily);
    }
    if (values.longTermSickDisabled !== undefined && typeof values.longTermSickDisabled !== 'number') {
      values.longTermSickDisabled = Number(values.longTermSickDisabled);
    }
    if (values.other !== undefined && typeof values.other !== 'number') {
      values.other = Number(values.other);
    }

    const entity = {
      ...economicActivityStatusEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          geographicLevel: 'EXTRA_WARD',
          ...economicActivityStatusEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="apiLocationApp.economicActivityStatus.home.createOrEditLabel" data-cy="EconomicActivityStatusCreateUpdateHeading">
            <Translate contentKey="apiLocationApp.economicActivityStatus.home.createOrEditLabel">
              Create or edit a EconomicActivityStatus
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="economic-activity-status-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('apiLocationApp.economicActivityStatus.geographicLevel')}
                id="economic-activity-status-geographicLevel"
                name="geographicLevel"
                data-cy="geographicLevel"
                type="select"
              >
                {geographicLevelValues.map(geographicLevel => (
                  <option value={geographicLevel} key={geographicLevel}>
                    {translate(`apiLocationApp.GeographicLevel.${geographicLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('apiLocationApp.economicActivityStatus.date')}
                id="economic-activity-status-date"
                name="date"
                data-cy="date"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.economicActivityStatus.geography')}
                id="economic-activity-status-geography"
                name="geography"
                data-cy="geography"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.economicActivityStatus.geographyCode')}
                id="economic-activity-status-geographyCode"
                name="geographyCode"
                data-cy="geographyCode"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.economicActivityStatus.totalAllUsualResidents')}
                id="economic-activity-status-totalAllUsualResidents"
                name="totalAllUsualResidents"
                data-cy="totalAllUsualResidents"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.economicActivityStatus.economicallyActiveTotal')}
                id="economic-activity-status-economicallyActiveTotal"
                name="economicallyActiveTotal"
                data-cy="economicallyActiveTotal"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.economicActivityStatus.inEmployment')}
                id="economic-activity-status-inEmployment"
                name="inEmployment"
                data-cy="inEmployment"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.economicActivityStatus.employeePartTime')}
                id="economic-activity-status-employeePartTime"
                name="employeePartTime"
                data-cy="employeePartTime"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.economicActivityStatus.employeeFullTime')}
                id="economic-activity-status-employeeFullTime"
                name="employeeFullTime"
                data-cy="employeeFullTime"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.economicActivityStatus.selfEmployed')}
                id="economic-activity-status-selfEmployed"
                name="selfEmployed"
                data-cy="selfEmployed"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.economicActivityStatus.unemployed')}
                id="economic-activity-status-unemployed"
                name="unemployed"
                data-cy="unemployed"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.economicActivityStatus.economicallyInactiveTotal')}
                id="economic-activity-status-economicallyInactiveTotal"
                name="economicallyInactiveTotal"
                data-cy="economicallyInactiveTotal"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.economicActivityStatus.retired')}
                id="economic-activity-status-retired"
                name="retired"
                data-cy="retired"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.economicActivityStatus.student')}
                id="economic-activity-status-student"
                name="student"
                data-cy="student"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.economicActivityStatus.lookingAfterHomeFamily')}
                id="economic-activity-status-lookingAfterHomeFamily"
                name="lookingAfterHomeFamily"
                data-cy="lookingAfterHomeFamily"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.economicActivityStatus.longTermSickDisabled')}
                id="economic-activity-status-longTermSickDisabled"
                name="longTermSickDisabled"
                data-cy="longTermSickDisabled"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.economicActivityStatus.other')}
                id="economic-activity-status-other"
                name="other"
                data-cy="other"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/economic-activity-status" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default EconomicActivityStatusUpdate;
